module.exports = __webpack_public_path__ + "static/media/x-close-icon.e8a34031.svg";